<!--US Page-->
<div class="dtfinsurance" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>

  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_FMV_Carousel_Dark.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'ElectricFMV.TruckTitleFMV' | translate }}
      </h2>
      <p class="mbfs-home-hero__header-text">
        {{ 'ElectricFMV.TruckHeaderFMV' | translate }}
      </p>
    </section>
  </section>

  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'ElectricFMV.DedicatedFMVHeader' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'ElectricFMV.DedicatedFMVCopy' | translate }}</p>
      </div>
    </div>
  </section>

  <!--Benefits you can count on 1-->
  <div class="mercedes-me-login__column">
    <h2 class="mercedes-me-login__column-headline">{{ 'ElectricFMV.FMVLeaseHeader' | translate }}</h2>
    <p class="paragraph1"> {{ 'ElectricFMV.FMVLeaseCopy' | translate }}</p>
    <p class="paragraph1"> {{ 'ElectricFMV.FMVLeaseCopy2' | translate }}</p>

    <ul class="dtfbrochures__columns2">
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Access_tech_Icon.png">
        <h4 class="header1"> {{ 'ElectricFMV.AccessTitleInsurance' | translate }}</h4>
        <p class="paragraph1"> {{ 'ElectricFMV.AccessCopyInsurance' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Walk-Away_Icon.png">
        <h4 class="header1"> {{ 'ElectricFMV.WalkTitleInsurance' | translate }}</h4>
        <p class="paragraph1"> {{ 'ElectricFMV.WalkCopyInsurance' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Various-Incentives_Icon.png">
        <h4 class="header1">{{ 'ElectricFMV.VariousTitleInsurance' | translate }}</h4>
        <p class="paragraph1">{{ 'ElectricFMV.VariousCopyInsurance' | translate }}</p>
      </li>
    </ul>
  </div>

  <!-- Protect Your investment-->
  <div class="dtfbrochures__page2">
    <div class="dtfbrochures__container2">
      <h4 class="dtfbrochures__header21">{{ 'ElectricFMV.FMVLeaseDetailsHeader' | translate }}</h4>
    <div class="dtfbrochures__columns2">
      <div class="row5">
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/eM2-Image.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy1' | translate }}</p>
          </div>
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/Technology-Road-Image.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy2' | translate }}</p>
         </div>
      </div>
      </div>
      <div class="dtfbrochures__columns2">
      <div class="row5">
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/eCascadia-Image.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy3' | translate }}</p>
         </div>
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/Dealer-Network.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy4' | translate }}</p>
         </div>
      </div>
      </div>
  </div>
</div>
<footer id="mbfs-footer">
  <div role="contentinfo">
    <div class="mbfs-copyright">
      <p class="paragraph1"> {{ 'ElectricFMV.Disclaimer' | translate }} </p>
    </div>
  </div>
</footer>
<section class='mbfs-red-banner-inner'>
  <div class="mbfs-red-banner-inner__box">
    <div class="mbfs-red-banner-inner__box--text">
      <h2 class="mbfs-red-banner-inner__header-title">
        {{'Calculator.Information' | translate }} 
        <a href="{{this.targetRedirect}}brochures">{{'Calculator.ClickHere' | translate }} </a>
        {{'FinanceLeaseSolutions.MoreInfo2' | translate }} <a href="{{this.targetRedirect}}dealerlocator"> {{
          'Header.FindADealer' | translate }}</a>
      </h2>
    </div>
  </div>
</section>
</div>

<div class="dtfinsurance" *ngIf="isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>

  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_FMV_Carousel_Dark.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'ElectricFMV.TruckTitleFMV' | translate }}
      </h2>
      <p class="mbfs-home-hero__header-text">
        {{ 'ElectricFMV.TruckHeaderFMV' | translate }}
      </p>
    </section>
  </section>

  <section class='mbfs-repay-banner-inner'>
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <h2 class="mbfs-repay-banner-inner__header-title">
          {{ 'ElectricFMV.DedicatedFMVHeader' | translate }}
        </h2>
        <p class="mbfs-repay-banner-inner__header-text2">{{ 'ElectricFMV.DedicatedFMVCopy' | translate }}</p>
      </div>
    </div>
  </section>

  <!--Benefits you can count on 1-->
  <div class="mercedes-me-login__column" style="padding: 15px;">
    <h2 class="mercedes-me-login__column-headline">{{ 'ElectricFMV.FMVLeaseHeader' | translate }}</h2>
    <p class="paragraph1"> {{ 'ElectricFMV.FMVLeaseCopy' | translate }}</p>
    <p class="paragraph1"> {{ 'ElectricFMV.FMVLeaseCopy2' | translate }}</p>

    <ul class="dtfbrochures__columns2">
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Access_tech_Icon.png">
        <h4 class="header1"> {{ 'ElectricFMV.AccessTitleInsurance' | translate }}</h4>
        <p class="paragraph1"> {{ 'ElectricFMV.AccessCopyInsurance' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Walk-Away_Icon.png">
        <h4 class="header1"> {{ 'ElectricFMV.WalkTitleInsurance' | translate }}</h4>
        <p class="paragraph1"> {{ 'ElectricFMV.WalkCopyInsurance' | translate }}</p>
      </li>
      <li class="li1">
        <img src="static/assets/img/dtf-assets/images/redesign/Various-Incentives_Icon.png">
        <h4 class="header1">{{ 'ElectricFMV.VariousTitleInsurance' | translate }}</h4>
        <p class="paragraph1">{{ 'ElectricFMV.VariousCopyInsurance' | translate }}</p>
      </li>
    </ul>
  </div>

  <!-- Protect Your investment-->
  <div class="dtfbrochures__page2">
    <div class="dtfbrochures__container2">
      <h4 class="dtfbrochures__header2">{{ 'ElectricFMV.FMVLeaseHeader' | translate }}</h4>
    <div class="dtfbrochures__columns2">
      <div class="row5">
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/eM2-Image.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy1' | translate }}</p>
          </div>
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/Technology-Road-Image.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy2' | translate }}</p>
         </div>
      </div>
      </div>
      <div class="dtfbrochures__columns2">
      <div class="row5">
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/eCascadia-Image.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy3' | translate }}</p>
         </div>
         <div class="col-sm-6">
            <img class ="smallimg" src="static/assets/img/dtf-assets/images/redesign/Dealer-Network.jpg">
            <p class="paragraph2"> {{ 'ElectricFMV.FMVLeaseDetailsCopy4' | translate }}</p>
         </div>
      </div>
      </div>
  </div>
</div>
<footer id="mbfs-footer">
  <div role="contentinfo">
    <div class="mbfs-copyright">
      <p class="paragraph1"> {{ 'ElectricFMV.Disclaimer' | translate }} </p>
    </div>
  </div>
</footer>
<section class='mbfs-red-banner-inner'>
  <div class="mbfs-red-banner-inner__box">
    <div class="mbfs-red-banner-inner__box--text">
      <h2 class="mbfs-red-banner-inner__header-title">
        {{'Calculator.Information' | translate }} 
        <a href="{{this.targetRedirect}}brochures">{{'Calculator.ClickHere' | translate }} </a>
        {{'FinanceLeaseSolutions.MoreInfo2' | translate }} <a href="{{this.targetRedirect}}dealerlocator"> {{
          'Header.FindADealer' | translate }}</a>
      </h2>
    </div>
  </div>
</section>
</div>


